import { combineEpics } from 'redux-observable';
import { getCatalogEpic } from './get-catalog';
import { getUserCatalogEpic } from './get-user-catalog';
import { sortCatalogEpic } from './sort-catalog';
import { getArtistCatalogEpic } from './get-artist-catalog';
import { updateCatalogAfterReleaseEpic } from './update-catalog-after-release';

const catalogEpic = combineEpics(
  getCatalogEpic,
  getUserCatalogEpic,
  getArtistCatalogEpic,
  sortCatalogEpic,
  updateCatalogAfterReleaseEpic
);

export default catalogEpic;
